export default "__VITE_ASSET__DjoPst8H__"